import { endPoints, getDocSearchServiceAPIEndPoint } from "./api-constants";
import { apiService } from "./base-api-service";
import { getJWTServiceToken } from "../utils/helpers";

class DocSearchService {
  DocSearchService(url) {
    return getDocSearchServiceAPIEndPoint(url);
  }
  UpdateDocSearchBulk(orgId, data) {
    const headers = { Authorization: "Bearer " + getJWTServiceToken() };
    const endpointPath = endPoints.docSearchService.SEARCH.replace("${orgId}", orgId);
    const fullEndpoint = this.DocSearchService(endpointPath);
    return apiService.post(fullEndpoint, data, headers);
  }
}
export default new DocSearchService();
